import adminApi from 'services/admin/adminApi';

/**
 * Fetches order search suggestions.
 * 
 * @param {Object} params - Search parameters
 * @param {string} params.term - Search term
 * @param {string|number} params.organisation_id - Organization ID
 * @returns {Promise<Object>} API response
 */
export const fetchOrderSuggestions = async ({ term, organisation_id, warehouse_id }) => {
    return await adminApi.getSearchSuggestions('order-by-id', { term, organisation_id, warehouse_id });
};

export const checkTicketAssignable = async (orderId) => {
    try {
        const response = await adminApi.checkTicketAssignable(orderId);
        if (response?.success) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error checking ticket assignable:', error);
        return null;
    }
};

export const getLabel = (option) => {
    return String(option);
};
